import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import GalleryType from "../../types/Gallery";
import Gallery from "../../components/Gallery";

import { PubNub } from "../../api/Realtime";
import API from "../../api";
import World from "../../world";

const pubNubSubKey = process.env.NEXT_PUBLIC_PUB_NUB_SUB_KEY;
const pn = new PubNub(pubNubSubKey);
const api = new API(pn);
const world = new World(api, {
    short_domain: process.env.NEXT_PUBLIC_SHORT_DOMAIN,
});

const Page = () => {
    return (
        <>
            <Head>
                <title>Gallery - TacBoard</title>
                <meta name="description" content="View your event's phone number and pictures" />
                <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato:400,300,100|Gochi+Hand|Lobster" />
                <link rel="stylesheet" type="text/css" href="/css/gallery.css" />
            </Head>

            <Wrapper world={world} />
        </>
    );
}

type WrapperProps = {
    world: World;
};

const Wrapper = (props: WrapperProps) => {
    const [gallery, setGallery] = useState<GalleryType | null>(null);
    const [err, setErr] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const router = useRouter();

    useEffect(() => {
        let active = true;

        if (gallery) {
            return;
        }
        if (!router.query.id) {
            return;
        }

        (async function() {
            const [name, err] = await props.world.getGallery(`hosts/0/galleries/${router.query.id}`);
            if (err) {
                if (err.status == 401 || err.status == 403) {
                    window.location.href = "/unauthorized";
                    return;
                }
                setErr(err.message);
                return;
            }
            if (active) {
                setGallery(props.world.galleries[name]);
                setIsOpen(props.world.galleries[name].phone && router.query.mode === "live");
            }
        }())

        return () => {
            active = false;
        };
    }, [router.query.id]);

    if (gallery) {
        return <Gallery world={props.world} is_open={isOpen} gallery={gallery} />
    }

    if (err) {
        return (
            <>
                <h1>Failed to load</h1>
                <p>{err}</p>
            </>
        );
    }

    return <p>Loading...</p>
}
export default Page;
